import { Component, Input } from "@angular/core";

@Component({
    selector: "app-account-card-v2",
    templateUrl: "./account-card.component.html",
    styleUrls: ["./account-card.component.scss"],
    standalone: false
})
export class AccountCardComponent {
    @Input() title: string;

    constructor() {}
}
